export const ccStyles = {
  commonStyles: {
    body: {
      overflow: 'hidden'
    },
    input: {
      width: '100%',
      height: '48px',
      borderRadius: '0',
      textOverflow: 'ellipsis',
      lineHeight: '1.5',
      border: '1px solid rgb(194, 195, 201)',
      backgroundColor: 'rgb(255,255,255)',
      fontFamily: 'Manulife JH Sans,Helvetica,Arial,Sans-serif',
      fontWeight: '400',
      fontSize: '16px',
      padding: '0rem 0.9rem !important'
    },
    'input:hover': {
      outline: 'none'
    },
    label: {
      marginBottom: '8px',
      fontFamily: 'Manulife JH Sans,Helvetica,Arial,Sans-serif',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '24px',
      flexGrow: '1',
      display: 'inline-block',
      color: '#34384b'
    }
  },
  elementStyle: {
    ccInputStyle: {
      width: '335px',
      padding: '12px'
    },
    expiryInputStyle: {
      width: '148px',
      marginBottom: '30px'
    },
    cvdInputLabelStyle: {
      marginTop: '-108px',
      marginLeft: '212px'
    },
    cvdInputStyle: {
      width: '148px',
      marginTop: '-80px',
      marginLeft: '200px'
    }
  },
  height: '80px',
  width: '335px'
};

export const ccStylesMobile = {
  commonStyles: {
    ...ccStyles.commonStyles,
    input: {
      ...ccStyles.commonStyles.input,
      width: '100%',
      marginBottom: '0px'
    },
    label: {
      ...ccStyles.commonStyles.label
    }
  },
  elementStyle: {
    expiryInputStyle: {
      width: '116px'
    },
    cvdInputStyle: {
      width: '116px'
    }
  },
  height: '80px',
  width: '100%'
};
